import { ReflectionStatus } from "../types";

interface Props {
  reflectionStatus?: ReflectionStatus;
  progressPercent: number | null;
  colorOverride?: string;
  percentColorOverride?: string;
}

const COLOR_MAP: Record<ReflectionStatus, string> = {
  on_track: "#22c55e",
  some_challenges: "#f59e0b",
  unlikely_to_reach: "#ef4444",
};

const ReflectionProgressBar = ({
  reflectionStatus,
  progressPercent = 0,
  colorOverride,
  percentColorOverride,
}: Readonly<Props>) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <div className="w-[120px] h-[6px] bg-gray-200 rounded-full overflow-hidden">
        <div
          className={"h-full rounded-full"}
          style={{
            backgroundColor:
              colorOverride ||
              (reflectionStatus && COLOR_MAP[reflectionStatus]) ||
              "#ef4444",
            width: `${progressPercent}%`,
          }}
        />
      </div>
      <span
        className="text-sm text-muted min-w-[32px]"
        style={{ color: percentColorOverride }}
      >
        {progressPercent}%
      </span>
    </div>
  );
};

export default ReflectionProgressBar;
